// extracted by mini-css-extract-plugin
export default {"root":"_2p0-Y","left":"_1skNk","left-side-item-wrapper":"_3GH78","leftSideItemWrapper":"_3GH78","right":"_2mPeS","right-side-item-wrapper":"l4eCd","rightSideItemWrapper":"l4eCd"};